/* Puts a warning banner at the top of charts */
import {clsx} from 'clsx';
import React, {useEffect} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Popup} from 'semantic-ui-react';

import {useDatadogRum} from '../util/datadog/datadogRum';

type PlotWarningType =
  | 'bar-chart-group-limits-exceeded'
  | 'group-subsampling'
  | 'grouped-runs-exceed-max-groups'
  | 'grouped-runs-exceed-max-runs'
  | 'grouped-runs'
  | 'histogram-multi-runs'
  | 'multi-metric'
  | 'number-of-runs-exceed-max-runs'
  | `max-runs-exceeded-${string}`;

type PlotWarningProps = {
  message: string;
  helpText?: string;
  disallowSelect?: boolean;
  type: PlotWarningType;
};

const PlotWarning: React.FC<PlotWarningProps> = React.memo(
  ({message, helpText, disallowSelect, type}) => {
    const DD_RUM = useDatadogRum();
    useEffect(() => {
      DD_RUM.addAction('Line_plot_legend_warning', {
        type,
        message,
      });
    }, [DD_RUM, type, message]);

    const span = (
      <span
        className={clsx('plot-warning night-aware', {
          'select-none': disallowSelect,
        })}>
        {message}
      </span>
    );

    if (helpText == null) {
      return span;
    }

    return (
      <Popup
        inverted
        size="mini"
        position="bottom center"
        content={helpText}
        flowing
        popperModifiers={{
          preventOverflow: {
            // prevent popper from erroneously constraining the popup to the
            // table header
            boundariesElement: 'viewport',
          },
        }}
        trigger={span}
      />
    );
  }
);

export default PlotWarning;
